
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_pcgz5_pynh7_153",
  "slider": "awsui_slider_pcgz5_pynh7_190",
  "slider-track": "awsui_slider-track_pcgz5_pynh7_194",
  "slider-range": "awsui_slider-range_pcgz5_pynh7_194",
  "disabled": "awsui_disabled_pcgz5_pynh7_209",
  "readonly": "awsui_readonly_pcgz5_pynh7_213",
  "error": "awsui_error_pcgz5_pynh7_222",
  "warning": "awsui_warning_pcgz5_pynh7_225",
  "active": "awsui_active_pcgz5_pynh7_228",
  "error-active": "awsui_error-active_pcgz5_pynh7_231",
  "warning-active": "awsui_warning-active_pcgz5_pynh7_234",
  "labels": "awsui_labels_pcgz5_pynh7_245",
  "labels-noref": "awsui_labels-noref_pcgz5_pynh7_251",
  "labels-reference": "awsui_labels-reference_pcgz5_pynh7_254",
  "labels-min": "awsui_labels-min_pcgz5_pynh7_261",
  "labels-max": "awsui_labels-max_pcgz5_pynh7_267",
  "labels-aria-description": "awsui_labels-aria-description_pcgz5_pynh7_275",
  "ticks": "awsui_ticks_pcgz5_pynh7_293",
  "ticks-wrapper": "awsui_ticks-wrapper_pcgz5_pynh7_299",
  "tick": "awsui_tick_pcgz5_pynh7_293",
  "middle": "awsui_middle_pcgz5_pynh7_314",
  "filled": "awsui_filled_pcgz5_pynh7_317",
  "tooltip-thumb": "awsui_tooltip-thumb_pcgz5_pynh7_345",
  "thumb": "awsui_thumb_pcgz5_pynh7_358",
  "min": "awsui_min_pcgz5_pynh7_394",
  "max": "awsui_max_pcgz5_pynh7_397"
};
  